<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from "_vue@2.6.14@vue";
export default {
  name: "App",
  created() {},
  mounted() {
    let screenWidth = window.screen.width;
    let screenHeight = window.screen.height;
    let rate = screenWidth / 1920;

    this.$el.style.height = screenHeight / rate + "px";

    console.log("screenWidth:" + screenWidth);

    if (screenWidth > 1900) {
      this.$el.style.transform = "scale(1)";
    } else {
      this.$el.style.transform = "scale(" + rate + ")";
    }

  },
  methods: {
    myResize: function () {
      console.log("resize");
      let that = this;
      window.onresize = function temp() {
        let screenWidth = window.screen.width;
        let screenHeight = window.screen.height;
        let rate = screenWidth / 1920;

        if (screenWidth > 1900) {
          that.$el.style.transform = "scale(1)";
        } else {
          that.$el.style.transform = "scale(" + rate + ")";
        }
      };
    },


  },
};
</script>

<style>
html,
body {
  font-size: 16px;
}

#app {
  width: 1920px;
  height: 1080px;
  position: absolute;
  left: 0;
  top: 0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: auto;
  overflow-y: auto;
  transform-origin: 0 0;
  transform: scale(0.666666666667);
}
#app ::-webkit-scrollbar {
  display: none;
}

@media only screen and (min-width: 1900px) {
  #app {
    transform: scale(1);
  }
}

@media only screen and (min-height: 1200px) {
  #app {
    height: 1200px;
  }
}

@media screen and (orientation: portrait) {
  #app {
    transform: rotate(90deg);
  }
}

</style>




// WEBPACK FOOTER //
// src/App.vue